import React, { Suspense, lazy, useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from './helpers/state';
import { createRoot } from 'react-dom/client';
import SignalRProvider from './SignalRProvider';

const container = document.getElementById('root');
const root = createRoot(container);

// Lazy load the i18n initialization
const loadI18n = () => import('./i18n');

const LazyBootstrap = lazy(() => import('./helpers/bootstrap'));

const LoadingFallback = () => (
  <div id="MainArea" autoscroll="true">
    <section id="content-wrapper">
      <div className="centre">
        <section id="preloader">
          <div className="spinner"></div>
        </section>
      </div>
    </section>
  </div>
)
  
const App = () => {
  const [i18nInstance, setI18nInstance] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadI18n()
      .then(module => {
        setI18nInstance(module.default);
      })
      .catch(err => {
        console.error('Failed to load i18n:', err);
        setError(err);
      });

  }, []);

  if (error) {
    return (
      <div id="MainArea" autoscroll="true">
        <section id="content-wrapper">
          <div className="centre">
            <h1>Error loading application</h1>
            <p>{error.message}</p>
          </div>
        </section>
      </div>
    );
  }

  if (!i18nInstance) {
    return <LoadingFallback />;
  }

  return (
    <I18nextProvider i18n={i18nInstance}>
      <Provider>
        <BrowserRouter>
          <Suspense fallback={<LoadingFallback />}>
            <SignalRProvider>
              <LazyBootstrap />
            </SignalRProvider>
          </Suspense>
        </BrowserRouter>
      </Provider>
    </I18nextProvider>
  );
};

root.render(

  <React.StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <App />
    </Suspense>
  </React.StrictMode>
);